
class exports.Heading

    constructor: ->
        @id = null
        @display_name = ''
        @columns = []
